exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3rpcf{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#000;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3rpcf,._3rpcf._2jW0m video{width:100%;height:100%}._3rpcf._3yR8u{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._3rpcf._3yR8u._15m4- video{width:100%}._3rpcf._3yR8u._3DN9A video{height:100%}._3rpcf._16beL{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3rpcf._16beL._15m4- video{height:100%}._3rpcf._16beL._3DN9A video{width:100%}._3rpcf video{position:relative;z-index:1;-webkit-box-shadow:0 0 20px rgba(0,0,0,.2);box-shadow:0 0 20px rgba(0,0,0,.2)}._3rpcf._39MQ6{cursor:none}.D2-oY{position:absolute;z-index:0;top:0;right:0;bottom:0;left:0;-webkit-filter:blur(14px);filter:blur(14px)}", ""]);

// exports
exports.locals = {
	"screen": "_3rpcf",
	"regularMode": "_2jW0m",
	"verticalVideo": "_3yR8u",
	"fillMode": "_15m4-",
	"blurMode": "_3DN9A",
	"horizontalVideo": "_16beL",
	"hiddenCursor": "_39MQ6",
	"backgroundCanvas": "D2-oY"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!../node_modules/playable/dist/src/modules/ui/screen/screen.scss
// module id = 100
// module chunks = 0